import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisMapChartItemDto,
  IAnalysisMapChartItemVo,
  IAnalysisMapChartResponseDto,
  IAnalysisMapChartResultVo,
} from '../types';

import { pickChartDisplayMeta } from './common';

function normalizeMapChartValueArray(
  value: unknown[] | null | undefined,
): unknown[] {
  return Array.isArray(value) ? value : [];
}

function normalizeMapChartItem(
  item: IAnalysisMapChartItemDto,
): IAnalysisMapChartItemVo {
  const {
    metric,
    value_type: valueType,
    min,
    max,
    map_chart_value: mapChartValueWire,
  } = item;

  return {
    metric,
    valueType,
    min,
    max,
    mapChartValue: normalizeMapChartValueArray(mapChartValueWire),
  };
}

export function transformMapChartResponseDtoToVo(
  dto: IAnalysisMapChartResponseDto,
): IAnalysisMapChartResultVo {
  const { map_charts: mapChartsWire } = dto;
  const mapDataWire = Array.isArray(mapChartsWire)
    ? mapChartsWire[0]
    : undefined;

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.Map,
    mapData: mapDataWire ? normalizeMapChartItem(mapDataWire) : undefined,
    /** 产品要求无数据也展示地图，与 Analysis `noData: false` 一致。 */
    isNoData: false,
  };
}
